import { createSlice } from "@reduxjs/toolkit";
import {
  createFinalAwardsAction,
  getFinalAwardsByCaseIDAction,
  updateFinalAwardsAction,
  deleteFinalAwardsAction,
} from "../../actions/FinalAwards/finalAwardsAction";

const initialState = {
  finalAwards: [],
  loading: false,
  error: null,
  success: false,
  successMessage: "",
};

const finalAwardsSlice = createSlice({
  name: "finalAwards",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFinalAwardsByCaseIDAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFinalAwardsByCaseIDAction.fulfilled, (state, action) => {
        state.loading = false;
        state.finalAwards = action.payload.FinalAwards || [];
      })
      .addCase(getFinalAwardsByCaseIDAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    // =========================================================================
    // CREATE FINAL AWARDS
    // =========================================================================
    builder
      .addCase(createFinalAwardsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createFinalAwardsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Final Awards created successfully";
        state.finalAwards.push(action.payload.data);
      })
      .addCase(createFinalAwardsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // UPDATE INTERIM ORDER
    // =========================================================================
    builder
      .addCase(updateFinalAwardsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateFinalAwardsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Final Awards updated successfully";

        const index = state.finalAwards.findIndex(
          (o) => o.finalAwards_ID === action.payload.finalAwards_ID,
        );

        if (index !== -1) {
          state.finalAwards[index] = action.payload;
        }
      })
      .addCase(updateFinalAwardsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // DELETE FINAL AWARDS
    // =========================================================================
    builder
      .addCase(deleteFinalAwardsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteFinalAwardsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Final Awards deleted successfully";

        state.finalAwards = state.finalAwards.filter(
          (o) => o.finalAwards_ID !== action.payload,
        );
      })
      .addCase(deleteFinalAwardsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearSuccess } = finalAwardsSlice.actions;

export default finalAwardsSlice.reducer;
